/* eslint-disable max-len */
export const getOrgModelAccess = (orgId, authKey) => async (dispatch) => {
  return ['Rikai2_new_model', 'RikAI2-Extract_new_model']
}

// const getNewModels = async (orgId, authKey) => {
//   try {
//     const url = `${process.env.REACT_APP_METRICS_URL}api/model-access?retrieve_org_id=${orgId}`
//     const res = await fetch(url, {
//       method: 'GET',
//       headers: {
//         'orgid': orgId,
//         'authkey': authKey,
//         'Content-Type': 'application/json',
//       },
//     })
//     const allAccess = await res.json()
//     const modelIds = allAccess['models'].filter((model) => model['name'] === 'Rikai2' || model['created_at'] > '2025-10').map((model) => model['name'] + '_new_model')
//     return modelIds
//   } catch (error) {
//     console.log(error)
//     return []
//   }
// }
